import {Component, OnInit, Input} from '@angular/core';
import {CarrierService} from 'app/services/carrier.service';
import {AuthWebService} from 'app/services/authweb.service';
import {Router, ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {DatePipe} from '@angular/common';
import {environment} from 'environments/environment';
import {CorspdcService} from 'app/services/corspdc.service';
import {CarriertransactionService} from 'app/services/carriertransaction.service';
import {UtilityServiceService} from 'app/services/utility-service.service';

var jsPDF = require('jspdf');
require('jspdf-autotable');


@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

    invoicedetails: any = {};
    @Input() dataCntrl: any;
    isLoading: boolean = false;
    isEmpty: boolean = false;
    user: any = {};
    page = 1
    count: number = 0;

    debtoraccount: any = {};
    referencenumber: string;
    carrierid: string;
    person_id: string;
    accountnumber: string;
    message = 'Submitting your request, please wait...';

    constructor(private carrierService: CarrierService, private authWebService: AuthWebService, private router: Router, public transData: CarriertransactionService, public utility: UtilityServiceService,
                private toaster: ToastrService, public datepipe: DatePipe, private route: ActivatedRoute, private crspdService: CorspdcService) {
        this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
    }

    ngOnInit() {

        this.route.paramMap.subscribe(params => {
            this.accountnumber = params.get('id');
            this.referencenumber = params.get('referencenumber');
            this.carrierid = params.get('carrierid');
            this.utility.setShowStatementFooter(true);
        })
        this.utility.setShowStatementFooter(true);
        this.loadinvoice(this.referencenumber);
        this.getDebtorAccount(this.accountnumber);
        this.getCarrier();

    }

    loadinvoice(invoicenumber: string) {

        this.isLoading = true;
        // //console.log('user.ID = ', this.user.Id);
        this.carrierService.getInvoice(invoicenumber).subscribe((result: any) => {
            this.invoicedetails = result;
            this.count = result.Count;
            this.isEmpty = (this.count == 0) ? true : false;
            console.dir(this.invoicedetails);
            this.isLoading = false;
            this.transData.invoicedetails = this.invoicedetails;
            this.transData.screen = 'invoice';
            this.transData.accountnumber = this.accountnumber;
            this.transData.carrierid = this.carrierid;
            this.transData.referencenumber = this.referencenumber;

        }, error => {
            this.isLoading = false;
            this.isEmpty = true;
            //console.log('Error occured: ' + error);

        })

    }

    getDebtorAccount(custcode: string) {
        this.carrierService.getDebtorAccount(custcode).subscribe((result: any) => {

            this.debtoraccount = result;
            this.count = result.Count;
            //console.log(this.count);
            console.dir(this.debtoraccount);
            this.transData.debtoraccount = this.debtoraccount;
        }, error => {
            //console.log('Error occured: ' + error);
        })

    }


    getCarrier() {
        this.carrierService.carrierPersonByuserId(Number(this.user.Id)).subscribe((result: any) => {
            this.person_id = result.person_id;
            this.transData.personid = this.person_id;
            //console.log(result);
        }, error => {
            //console.log(error);
        });
    }

}
